import {BaseService} from "./base.service";

class PromotersService extends BaseService {

    constructor() {
        super('api/promoters')
    }

}

export const promotersService = new PromotersService();
